/* eslint-disable no-unused-expressions */
import React from "react";

export const dispatchRef = React.createRef();

export default (action) => {
  dispatchRef.current(action);
};
